<script>

import {axios} from '../mixins';

export default {
  name: 'RecruiterCodeInput',

  components: {},

  mixins: [axios],

  props: {

    recruiter: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      code: null,
      selectedRecruiter: null,
      message: null,
    };
  },

  created() {
    this.selectedRecruiter = this.recruiter;
    window.addEventListener("keydown", this.keyListener);
  },

  methods: {
    getRecruiter() {
      this.message = null
      this.get('/recruiter?code=' + this.code).then((response) => {
        if (response.data.recruiter) {
          this.selectedRecruiter = response.data.recruiter
          this.code = null
        } else {
          console.log(response.data)
          this.message = response.message
        }
      }).catch((response) => {
        console.log(response);
      });
    },
    keyListener(event) {
      if (event.key === "Enter") {
        event.preventDefault(); // prevent default action from getting triggered.
      }
    },
  },
};

</script>

<template>
  <div>
    <div class="flex flex-col flex-wrap flex-1 my-1">
      <label for="recruiter_code" class="font-semibold">Referral Partner </label>

      <div>

        <input
            class="bg-secondary italic rounded-t border py-2 border-grey-lighter w-full px-3 leading-tight focus:outline-none text-md"
            placeholder="Search by Referral Partner Partner Code"
            :value="selectedRecruiter ? (selectedRecruiter.business_name ?? selectedRecruiter.name) : 'No Referral Partner'"
            readonly
            type="text">
        <input type="text" name="affiliate_recruiter" :value="selectedRecruiter ? selectedRecruiter.id : null" hidden>
      </div>

      <div v-if="!this.disabled" class="flex flex-row">
        <input name="recruiter_code"
               v-model="code"
               class="bg-secondary italic rounded-bl border-b border-l py-2 border-grey-lighter w-full px-3 leading-tight focus:outline-none text-md"
               placeholder="Search Referral Partner by Code"
               type="text">
        <button
            :class="`px-3 py-1 rounded-br text-white inline-block shadow-lg focus:bg-blue-darker font-bold ` + (code ? `bg-blue hover:bg-blue-dark` : `bg-blue-darker`)"
            :disabled="!code"
            type="button" @click="getRecruiter"><i class="fas fa-search"></i>
        </button>
      </div>

      <div class="text-red">
        {{ message }}
      </div>

    </div>
  </div>
</template>
